import React from "react";
import Seo from "../components/Seo";
import "../styles/pages/about.css";

function About() {
    return (
        <main className="page">
            <Seo
                title="About Us"
                path="/about"
                description="Learn more about Dahlia Health Care Services, our mission, values, and commitment to trusted staffing, care, training, children's services, and secure transport."
                keywords="about Dahlia Health Care Services, care provider, staffing services, health care support"
            />

            <div className="container">
                <div className="page-header">
                    <p className="eyebrow">About Dahlia Health Care Services</p>
                    <h1>Built around trust, dignity, and dependable service delivery</h1>
                    <p>
                        Dahlia Health Care Services exists to connect people and organizations with dependable support. We work across staffing, care delivery, training, children’s services, and secure transport with dignity, safety, and professionalism at the core.
                    </p>
                </div>

                <div className="about-showcase">
                    <div className="about-showcase__content">
                        <div className="about-intro">
                            <div className="about-intro__card">
                                <h2>Who We Are</h2>
                                <p>
                                    We are a service-led organization focused on providing thoughtful, reliable support across healthcare, care, and specialist service environments.
                                </p>
                            </div>
                            <div className="about-intro__card">
                                <h2>How We Work</h2>
                                <p>
                                    We listen carefully, plan responsibly, and deliver with consistency so individuals, families, and organizations can rely on us with confidence.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="about-showcase__image-wrap">
                        <img
                            className="about-showcase__image"
                            src="https://images.unsplash.com/photo-1527613426441-4da17471b66d?auto=format&fit=crop&w=900&q=80"
                            alt="Care professional and service user"
                        />
                    </div>
                </div>

                <div className="info-grid">
                    <div className="info-card">
                        <h2>Our Mission</h2>
                        <p>To provide trusted, compassionate, and effective services that improve outcomes for individuals, families, and organizations.</p>
                    </div>
                    <div className="info-card">
                        <h2>Our Vision</h2>
                        <p>To be known as a respected provider of quality care, reliable staffing, and specialist support across every service we deliver.</p>
                    </div>
                    <div className="info-card">
                        <h2>Our Values</h2>
                        <p>Compassion, accountability, safeguarding, respect, professionalism, and continuous improvement.</p>
                    </div>
                </div>

                <div className="dark-panel">
                    <div>
                        <p className="eyebrow eyebrow--light">What makes us different</p>
                        <h2>A balanced approach of professionalism and care</h2>
                        <p>
                            We understand that every family and organization has different priorities, which is why we focus on flexibility, tailored delivery, and open communication.
                        </p>
                    </div>
                    <ul>
                        <li>Tailored support plans and service packages</li>
                        <li>Responsive recruitment and workforce support</li>
                        <li>Safeguarding-led care and transport services</li>
                        <li>Practical, skills-based mental health training</li>
                    </ul>
                </div>
            </div>
        </main>
    );
}

export default About;